export default __webpack_public_path__ + "static/media/MD-Piktogramm.fa40b706.svg";